// extracted by mini-css-extract-plugin
export default {"container":"companyAlerts_container__58sWr","alertTabs":"companyAlerts_alertTabs__NbbIT","tabList":"companyAlerts_tabList__vurXQ"};